import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";
import { html } from "../../../../../utils/tw";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;
  Components.addType("multi-section", {
    model: {
      defaults: {
        draggable: true,
        droppable: false,
        components: /*html*/ `
          <section class="py-6 container mx-auto px-4 ">
            <div class="grid md:grid-cols-2 gap-y-4 gap-x-20 items-center">
              <div class="space-y-2">
                <h2 class="md:text-3xl text-xl font-semibold">Efficient Transportation Networks</h2>
                <p class="md:text-xl text-lg">
                  Streamlining delivery routes to ensure timely and safe
                  transportation for every shipment
                </p>
              </div>
              <div class="  flex justify-end">
                <img
                  src=""
                  alt="section-image"
                  class="w-96 h-full object-contain"
                />
              </div>
              <div class="">
                <img
                  src=""
                  alt="section-image"
                  class="w-96  h-full object-contain"
                />
              </div>
              <div class="space-y-2">
              <h2 class="md:text-3xl text-xl font-semibold">Efficient Transportation Networks</h2>
              <p class="md:text-xl text-lg">
                Streamlining delivery routes to ensure timely and safe
                transportation for every shipment
              </p>
            </div>
            </div>
          </section>
        `,
        traits: [
          {
            type: "text",
            name: "icon",
            label: "Icon",
            changeProp: true,
          },
          {
            type: "text",
            name: "title",
            label: "Title",
            changeProp: true,
          },
        ],
      },
    },
  });
};
